import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { Check } from 'src/app/shared/models/check';
import { CheckDto, CheckSeatDto } from 'src/app/shared/models/check-dto';
import { CheckSeat } from 'src/app/shared/models/check-seat.model';
import { CustomerDto } from 'src/app/shared/models/DTO/customer-dto';
import { OOOrderType } from 'src/app/shared/models/oo-order-type';

@Component({
	selector: 'app-check-record-viewer',
	templateUrl: './check-record-viewer.component.html',
	styleUrls: ['../commandcenter.scss'],
})
export class CheckRecordViewerComponent implements OnInit {
	@Input() incomingCheck: Check;
	@Input() checkKey: string;
	@Input() venueKey: number;

	check: Check;
	customer: CustomerDto;

	moment: any = moment;

	orderTypes: OOOrderType[];

	receiptUrl: string;

	seatKey: number = 1;
	seatSelected: CheckSeat;
	showCheckKey: boolean = false;
	showToken: boolean = false;
	viewCustomer: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (!this.incomingCheck && this.checkKey) {
			this.getCheck(this.venueKey, this.checkKey);
		} else {
			this.check = new Check(this.incomingCheck);
			this.init();
		}
	}
	async init() {
		console.log(this.check.checkKey);
		if (this.check.customerKey) {
			this.getCustomer(this.check.customerKey);
		}
		this.selectSeat(this.check.seats[0].seatKey);
		this.check.seats = this.venueService.parseSeat(this.check.seats);
		this.check.seats.forEach((seat) => {
			seat.payments?.forEach((payment) => {
				if (payment.authorization) {
					payment.authorization = JSON.parse(payment.authorization);
					payment['authCode'] = payment.authorization['authCode'] || undefined;
					payment['account'] = payment.authorization['cardNumber'] || undefined;
					payment['cardType'] = payment.authorization['cardType'] || undefined;
					payment['transId'] = payment.authorization['transId'] || undefined;
				}
			});
		});
	}

	async getCheck(venueKey: number, checkKey: string) {
		const resp: Check = await this.focuslink.getCheck(venueKey, checkKey);
		this.check = new Check(resp);
		this.init();
	}

	async getCustomer(customerKey: string) {
		const resp = await this.focuslink.customerGetOne(this.check.venueKey, customerKey);
		this.customer = new CustomerDto(resp);
	}

	selectSeat(seatKey: number) {
		this.seatSelected = this.check.seats.find((i) => i.seatKey === seatKey);
		this.seatKey = this.seatSelected.seatKey;
		let baseUrl: string = this.check.venueKey === 7166 ? 'https://dev.onlineorder.focuspos.com/' : 'https://app.focuspos.com/';
		if (window.location.hostname === 'localhost') {
			baseUrl = 'http://localhost:4200/';
		}
		this.receiptUrl = `${baseUrl}receipts/${btoa(`${this.check.checkKey}#${this.seatKey}`)}`;
	}
}
